import React from "react";
import { Table, Spinner } from "react-bootstrap";
import { BsThreeDots } from "react-icons/bs";
import formatDate from "../../utils/formatDate";
import {
  PaymentMethodBadge,
  StatusBadge,
  AppointmentStatusBadge,
  SessionTypeCell,
} from "./SessionBadges";

const SessionsTable = ({
  sessionsLoading,
  paginateAppointments,
  sessions,
  sortConfig,
  handleSort,
  handleDropdownToggle,
  paymentDataBySession,
  showBillingDetails = false,
}) => {
  if (sessionsLoading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <div className="mt-3 text-muted">Loading sessions...</div>
      </div>
    );
  }

  return (
    <div
      className="sessions-table-wrapper"
      style={{
        overflowX: "hidden",
        overflowY: "visible",
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
        position: "relative",
        minWidth: 0,
        display: "block",
        margin: 0,
        padding: 0,
      }}
    >
      <Table
        hover
        style={{
          marginBottom: 0,
          width: "100%",
          tableLayout: "fixed",
          display: "table",
          borderCollapse: "collapse",
          borderSpacing: 0,
          border: "none",
        }}
      >
        <thead
          style={{
            backgroundColor: "#064260",
            borderRadius: "0",
            color: "white",
            border: "none",
            borderWidth: 0,
            borderStyle: "none",
            outline: "none",
            boxShadow: "none",
          }}
        >
          <tr style={{ border: "none", outline: "none", boxShadow: "none" }}>
            <th
              style={{
                padding: "12px 8px",
                textAlign: "left",
                fontWeight: 600,
                fontSize: "11px",
                whiteSpace: "nowrap",
                cursor: "pointer",
                verticalAlign: "middle",
                width: "7%",
              }}
            >
              Session ID
            </th>

            <th
              style={{
                padding: "12px 8px",
                textAlign: "left",
                fontWeight: 600,
                fontSize: "11px",
                whiteSpace: "nowrap",
                verticalAlign: "middle",
                width: "11%",
              }}
            >
              Client
            </th>

            <th
              style={{
                padding: "12px 8px",
                textAlign: "left",
                fontWeight: 600,
                fontSize: "11px",
                whiteSpace: "nowrap",
                cursor: "pointer",
                verticalAlign: "middle",
                width: "11%",
              }}
              onClick={() => handleSort("provider")}
            >
              Provider{" "}
              {sortConfig.key === "provider" &&
                (sortConfig.direction === "asc" ? "↑" : "↓")}
            </th>

            <th
              style={{
                padding: "12px 8px",
                textAlign: "left",
                fontWeight: 600,
                fontSize: "11px",
                whiteSpace: "nowrap",
                cursor: "pointer",
                verticalAlign: "middle",
                width: "9%",
              }}
              onClick={() => handleSort("date")}
            >
              Date{" "}
              {sortConfig.key === "date" &&
                (sortConfig.direction === "asc" ? "↑" : "↓")}
            </th>

            {!showBillingDetails && (
              <>
                <th
                  style={{
                    padding: "12px 8px",
                    textAlign: "left",
                    fontWeight: 600,
                    fontSize: "11px",
                    whiteSpace: "nowrap",
                    verticalAlign: "middle",
                    width: "11%",
                  }}
                >
                  Time
                </th>

                <th
                  style={{
                    padding: "12px 8px",
                    textAlign: "left",
                    fontWeight: 600,
                    fontSize: "11px",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                    verticalAlign: "middle",
                    width: "11%",
                  }}
                  onClick={() => handleSort("sessionType")}
                >
                  Session Type{" "}
                  {sortConfig.key === "sessionType" &&
                    (sortConfig.direction === "asc" ? "↑" : "↓")}
                </th>

                <th
                  style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    fontWeight: 600,
                    fontSize: "11px",
                    whiteSpace: "nowrap",
                    verticalAlign: "middle",
                    width: "10%",
                  }}
                >
                  Session Status
                </th>
              </>
            )}

            <th
              style={{
                padding: "12px 8px",
                textAlign: "center",
                fontWeight: 600,
                fontSize: "11px",
                whiteSpace: "nowrap",
                cursor: "pointer",
                verticalAlign: "middle",
                width: "12%",
                minWidth: "130px",
              }}
              onClick={() => handleSort("paymentMethod")}
            >
              Payment Method{" "}
              {sortConfig.key === "paymentMethod" &&
                (sortConfig.direction === "asc" ? "↑" : "↓")}
            </th>

            {!showBillingDetails ? (
              <th
                style={{
                  padding: "12px 8px",
                  textAlign: "center",
                  fontWeight: 600,
                  fontSize: "11px",
                  whiteSpace: "nowrap",
                  cursor: "pointer",
                  verticalAlign: "middle",
                  width: "9%",
                }}
                onClick={() => handleSort("status")}
              >
                Payment Status{" "}
                {sortConfig.key === "status" &&
                  (sortConfig.direction === "asc" ? "↑" : "↓")}
              </th>
            ) : (
              <>
                <th
                  style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    fontWeight: 600,
                    fontSize: "11px",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                    verticalAlign: "middle",
                    width: "9%",
                  }}
                >
                  Payment Status
                </th>

                <th
                  style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    fontWeight: 600,
                    fontSize: "11px",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                    verticalAlign: "middle",
                    width: "9%",
                  }}
                >
                  Amount
                </th>

                <th
                  style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    fontWeight: 600,
                    fontSize: "11px",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                    verticalAlign: "middle",
                    width: "9%",
                  }}
                >
                  Insurance Status
                </th>
              </>
            )}

            <th
              style={{
                padding: "12px 8px",
                textAlign: "center",
                fontWeight: 600,
                fontSize: "11px",
                whiteSpace: "nowrap",
                verticalAlign: "middle",
                width: "8%",
              }}
            >
              Actions
            </th>
          </tr>
        </thead>

        <tbody>
          {paginateAppointments.length > 0 ? (
            paginateAppointments.map((session, index) => {
              return (
                <tr
                  key={session._id}
                  style={{
                    borderBottom: "1px solid #f8f9fa",
                    backgroundColor: index % 2 === 0 ? "#F8FAFC" : "#FFFFFF",
                  }}
                >
                  <td
                    style={{
                      color: "#064260",
                      fontWeight: "600",
                      padding: "12px 8px",
                      textAlign: "left",
                      verticalAlign: "middle",
                      whiteSpace: "nowrap",
                      fontSize: "13px",
                      width: "7%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {session.appointment_id || session._id?.slice(-4) || "N/A"}
                  </td>

                  <td
                    style={{
                      padding: "12px 8px",
                      fontSize: "13px",
                      textAlign: "left",
                      verticalAlign: "middle",
                      whiteSpace: "nowrap",
                      width: "11%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {session?.user?.firstname} {session?.user?.lastname}
                  </td>

                  <td
                    style={{
                      padding: "12px 8px",
                      fontSize: "13px",
                      textAlign: "left",
                      verticalAlign: "middle",
                      whiteSpace: "nowrap",
                      width: "11%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {session?.health_specialist?.firstname}{" "}
                    {session?.health_specialist?.lastname}
                  </td>

                  <td
                    style={{
                      padding: "12px 8px",
                      fontSize: "13px",
                      textAlign: "left",
                      verticalAlign: "middle",
                      whiteSpace: "nowrap",
                      width: "9%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {session.appointmenttime
                      ? formatDate(session.appointmenttime, "date")
                      : session.appointmentdate
                        ? formatDate(session.appointmentdate, "date")
                        : "N/A"}
                  </td>
                  {!showBillingDetails && (
                    <>
                      <td
                        style={{
                          padding: "12px 8px",
                          fontSize: "13px",
                          textAlign: "left",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                          width: "11%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {session.appointmenttime
                          ? `${formatDate(session.appointmenttime, "time")} - ${formatDate(session.appointmentEndTime, "time")}`
                          : "N/A"}
                      </td>

                      <td
                        style={{
                          padding: "12px 8px",
                          fontSize: "13px",
                          textAlign: "left",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                          width: "11%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <SessionTypeCell session={session} />
                      </td>

                      <td
                        style={{
                          padding: "12px 8px",
                          fontSize: "13px",
                          textAlign: "center",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                          width: "10%",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <AppointmentStatusBadge session={session} />
                        </div>
                      </td>
                    </>
                  )}

                  <td
                    style={{
                      padding: "12px 8px",
                      fontSize: "13px",
                      textAlign: "center",
                      verticalAlign: "middle",
                      whiteSpace: "nowrap",
                      width: "12%",
                      minWidth: "130px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <PaymentMethodBadge
                        session={session}
                        paymentDataBySession={paymentDataBySession}
                      />
                    </div>
                  </td>

                  {!showBillingDetails ? (
                    <td
                      style={{
                        padding: "12px 8px",
                        fontSize: "13px",
                        textAlign: "center",
                        verticalAlign: "middle",
                        whiteSpace: "nowrap",
                        width: "9%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <StatusBadge
                          session={session}
                          paymentDataBySession={paymentDataBySession}
                        />
                      </div>
                    </td>
                  ) : (
                    <>
                      <td
                        style={{
                          padding: "12px 8px",
                          fontSize: "13px",
                          textAlign: "center",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                          width: "9%",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <StatusBadge
                            session={session}
                            paymentDataBySession={paymentDataBySession}
                            showBillingDetails={showBillingDetails}
                          />
                        </div>
                      </td>

                      <td
                        style={{
                          padding: "12px 8px",
                          fontSize: "13px",
                          textAlign: "center",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                          color: "#575757",
                          fontWeight: "500",
                          width: "9%",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {session?.paymentData?.paymentMethod === "cash"
                            ? `$${session?.paymentData?.amount ? Math.floor(session.paymentData.amount) : 0}`
                            : ""}
                        </div>
                      </td>

                      <td
                        style={{
                          padding: "12px 8px",
                          fontSize: "13px",
                          textAlign: "center",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                          color: "#575757",
                          fontWeight: "500",
                          width: "9%",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        ></div>
                      </td>
                    </>
                  )}

                  <td
                    style={{
                      padding: "12px 8px",
                      fontSize: "13px",
                      textAlign: "center",
                      verticalAlign: "middle",
                      whiteSpace: "nowrap",
                      width: "8%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className="session-dropdown-button"
                        onClick={(e) => handleDropdownToggle(session._id, e)}
                        style={{
                          backgroundColor: "#27B99A",
                          border: "none",
                          borderRadius: "50%",
                          width: "30px",
                          height: "30px",
                          padding: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                      >
                        <BsThreeDots
                          style={{ fontSize: "18px", color: "#ffffff" }}
                        />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                className="text-center text-muted py-5"
                colSpan={showBillingDetails ? 8 : 10}
              >
                <div style={{ color: "#6c757d", fontSize: "18px" }}>
                  <i
                    className="fas fa-inbox fa-2x mb-3"
                    style={{ color: "#dee2e6" }}
                  ></i>
                  <br />

                  {sessions.length === 0 ? (
                    <>
                      <strong>No sessions match your filters.</strong>
                    </>
                  ) : (
                    <>
                      <strong>No sessions match your filters.</strong>
                      <br />
                      <small className="text-muted">
                        Try adjusting your search, date, or status filters.
                      </small>
                    </>
                  )}
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default SessionsTable;
